import styled from "styled-components"

export const NewCustomerFormContainer = styled.div`
  div[role="tabpanel"] {
    max-height: none;
    min-height: 558px;
  }
`
